import LoadingScreen from '@webstollen/react-native/lib/components/LoadingScreen'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { isLoaded } from 'react-redux-firebase'
import { useRouteMatch } from '@webstollen/react-native/lib/react-router'
import { SemVer } from 'semver'
import useStyles from './styles'
import LiveVisitorV1 from './v1'
import { Redirect } from '@webstollen/react-native/lib/react-router'
import { SessionContext } from '../../../../context/SessionContext'

const LiveTracker = () => {
  const styles = useStyles()

  const { t } = useTranslation()

  const match = useRouteMatch<{ shopId: string; visitorId: string }>()

  const { shopId, visitorId } = match.params

  const {
    shops,
    company: { authorizations },
  } = useContext(SessionContext)
  const shop = shops && shops[shopId]

  if (!isLoaded(shop) && !isLoaded(authorizations)) {
    return <LoadingScreen text={t('loading.shop')} />
  }

  if (!authorizations['page.customerJourney']) {
    return <Redirect to={'/upselling'} />
  }

  const version = new SemVer(shop.platform.sdkVersion)

  switch (version.major) {
    case 1:
      return <LiveVisitorV1 shop={shop} visitorId={visitorId} />
    default:
      return (
        <View style={styles.wrapper}>
          <View style={styles.container} />
        </View>
      )
  }
}

export default LiveTracker
